<template>

</template>

<script>

import {getPopCommentInfo} from "@/api/care/popCommentConfigController";
import {getRedeemInfo} from "@/api/care/orderCare";
import { mapState } from 'vuex'
const EXPOR_PUT_FILED = [
  "买家昵称",
  "买家号码",
  "实付金额(元)",
  "催付时间",
  "付款时间",
  "模板内容"
];
export default {
  props: {
    returnItem: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      changeColor: 'globalBG'
    })
  },
  data() {
    return {
      total: 0,
      isShowAll: false,
      tableLoading:false,
      pageNum: 1,
      menuType: "",
      pageSize: 10,
      tableList: []
    };
  },
  filters: {
    //展开收缩
    overFloatContent(d, s) {
      try {
        if (!s) {
          return d.length <= 20 ? d : d.substr(0, 20) + "...";
        } else {
          return d;
        }
      } catch (e) {
        return "...";
      }
    }
  },
  watch:{
    returnItem(newVal,oldVal){
      this._getPaymentInfoList();
    }
  },
  created() {
    this.menuType = this.$parent.$parent.asideActive;

    this._getPaymentInfoList();
  },
  methods: {
    //分页
    async handleCurrentChange(v) {
      this.pageNum = v;
      await this._getPaymentInfoList();
    },
    isShowTextAll() {
      this.isShowAll = !this.isShowAll;
    },

    //获取挽回数据List
    _getPaymentInfoList() {
      this.tableLoading = true
      let params = {

        current: this.pageNum, //(integer, optional): 当前页 ,
        size: this.pageSize, //(integer, optional): 每页大小 ,
        subTime: this.returnItem.subTime, //(string, optional): 短信提交时间 今日数据传入当日时间yyyy-MM-dd ,
        // type: this.returnItem.type 
      };

      params.type = this.returnItem.type
      getRedeemInfo(params).then(({data})=>{
        this.tableLoading = false
        this.tableList = data.records
        this.total = data.total
      })
     
      
    }
  }
};
</script>


